import type {ReactAction} from '@netx/core/bootstrap';
import {appRouter} from '@netx/core-next/instance/router';
import {faCheckSquare} from '@fortawesome/pro-solid-svg-icons';
import {canManageDownloadRequests} from '../enablers';
import {DownloadRequestsLabel} from '../locales';
import {DOWNLOAD_REQUEST_ROUTES} from './constants';

export const downloadRequestActionRequestsManageRouteIcon = faCheckSquare;

/**
 * Route to download requests management
 * @param params
 * @returns Action
 */
export const downloadRequestActionRequestsManageRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'download-requests-manage-route',
	cb: () => appRouter.navigate(DOWNLOAD_REQUEST_ROUTES.LIST, true),
	enableTest: () => canManageDownloadRequests(),
	icon: downloadRequestActionRequestsManageRouteIcon,
	get label() {
		return DownloadRequestsLabel.ROUTE;
	},
	routeMatch: /^share\/approvals(\/?)/,
	...params,
});
